import { Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';

//import { User } from '../../models/';
import { UscFirstComponent } from '../../components/usc-store/usc-first/usc-first.component';
import { UscHomeComponent } from '../../components/usc-store/usc-home/usc-home.component';
import { UscLastingComponent } from '../../components/usc-store/usc-lasting/usc-lasting.component';
import { UscMiddleComponent } from '../../components/usc-store/usc-middle/usc-middle.component';
import { UscReportsComponent } from '../../components/usc-store/usc-reports/usc-reports.component';
import { UscSearchComponent } from '../../components/usc-store/usc-search/usc-search.component';
import { User } from '../../models';
import { AdminService, ApiService, AuthService, MetadataService, SessionService } from '../../services';
import { UscStoreService } from '../../services/usc-store/usc-store.service';
import { UscSvtAppointmentsComponent } from '../usc-store-scheduling/usc-svt-appointments/usc-svt-appointments.component';
import { UscSvtCheckinComponent } from '../usc-store-scheduling/usc-svt-checkin/usc-svt-checkin.component';
import { UscSvtServiceCompletedComponent } from '../usc-store-scheduling/usc-svt-service-completed/usc-svt-service-completed.component';
import { UscSvtServingNowComponent } from '../usc-store-scheduling/usc-svt-serving-now/usc-svt-serving-now.component';
import { UscSvtWaitingComponent } from '../usc-store-scheduling/usc-svt-waiting/usc-svt-waiting.component';
import { UscActionPlanTableComponent } from './usc-action-plan-table/usc-action-plan-table.component';
import { UscBookOfBusinessComponent } from './usc-book-of-business/usc-book-of-business.component';
import { UscCalendarViewComponent } from './usc-calendar-view/usc-calendar-view.component';
import { UscCampaignImportComponent } from './usc-campaign-import/usc-campaign-import.component';
import { UscDialogComponent } from './usc-dialog/usc-dialog.component';
import { UscImpressionComponent } from './usc-impression/usc-impression.component';
import { UscManageCampaignComponent } from './usc-manage-campaign/usc-manage-campaign.component';
import { UscNextActionPlanComponent } from './usc-next-action-plan/usc-next-action-plan.component';
import { UscP2wAssociateDetailResultsComponent } from './usc-p2w-associate-detail-results/usc-p2w-associate-detail-results.component';
import { UscP2wCompetitionStatusComponent } from './usc-p2w-competition-status/usc-p2w-competition-status.component';
import { UscP2wCompetitionsComponent } from './usc-p2w-competitions/usc-p2w-competitions.component';
import { UscP2wSalesDetailsComponent } from './usc-p2w-sales-details/usc-p2w-sales-details.component';
import { UscP2wTeamActionPlansComponent } from './usc-p2w-team-action-plans/usc-p2w-team-action-plans.component';
import { UscP2wWaitingComponent } from './usc-p2w-waiting/usc-p2w-waiting.component';
import { UscPasswordComponent } from './usc-password/usc-password.component';
import { UscPayoutEstimatorComponent } from './usc-payout-estimator/usc-payout-estimator.component';
import { UscPrevActionPlanComponent } from './usc-prev-action-plan/usc-prev-action-plan.component';
import { UscRetailFoundationsComponent } from './usc-retail-foundations/usc-retail-foundations.component';
import { UscSalesScorecardComponent } from './usc-sales-scorecard/usc-sales-scorecard.component';
import { UscSalesTrackerComponent } from './usc-sales-tracker/usc-sales-tracker.component';
import { UscSmsHostingComponent } from './usc-sms-hosting/usc-sms-hosting.component';
import { UscTeamSalesTrackerComponent } from './usc-team-sales-tracker/usc-team-sales-tracker.component';
import { UscThisActionPlanComponent } from './usc-this-action-plan/usc-this-action-plan.component';
import { UscTodaysGoalComponent } from './usc-todays-goal/usc-todays-goal.component';
import { UscUserProfileComponent } from './usc-user-profile/usc-user-profile.component';
import { UscStoreSchedulingSetupComponent } from '../usc-store-scheduling/usc-store-scheduling-setup/usc-store-scheduling-setup.component';
import { UscUploadedDocumentsComponent } from './usc-uploaded-documents/usc-uploaded-documents.component';

@Component({
    selector: 'sn-usc-store',
    templateUrl: './usc-store.component.html',
    styleUrls: ['./usc-store.component.css']
})
export class UscStoreComponent implements OnInit {
    @ViewChild('usc_store_view', { read: ViewContainerRef }) viewContainer;
    currentView: string = "";
    private unsubscribe = new Subject<void>();

    userDefaultPageSub: any;
    redirectUserToDefaultPage: boolean = true;

    serialized_non_blocking_requests:string[] = [];

    constructor(
        private adminService: AdminService,
        private uscStoreService: UscStoreService,
        private metadataService: MetadataService,
        private authService: AuthService,
        private apiService: ApiService,
        private route: ActivatedRoute,
        private router: Router,
        private viewResolver: ComponentFactoryResolver,
        protected sessionService: SessionService,
        public ngbModal: NgbModal,
        public ngbActiveModal: NgbActiveModal,
    ) { 
    }

    currentViewFactory: ComponentFactory<any>;

    metaDataSub: Subscription;
    authSub: Subscription;
    currentUserSub: Subscription;
    portalReadySub: Subscription;
    p2wReadySub: Subscription;
    reloadP2WAchievementsSub: Subscription;
    idleTimerSub: Subscription;
    currentViewSub: Subscription;
    emailTemplatesSub: Subscription;
    allUsersSub: Subscription;
    searchTextSub: Subscription;
    gotoItemSub: Subscription;
    smsCensorshipSub: Subscription;
    dailyCampaignIntroSMSLimitSub: Subscription;
    todaysGoalSub: Subscription;
    getThisMonthActionPlansSub: Subscription;
    hasCurrentMonthQuotaChangedSub: Subscription;
    getTodaysGoalSub: Subscription;
    getPreviousActionPlansSub: Subscription;
    getConsultantSalesQuotaAchievementsSub: Subscription;
    getConsultantSalesGoalAchievementsSub: Subscription;
    getTodaysConsultantSalesGoalAchievementsSub: Subscription;
    getStoreSalesQuotaAchievementsSub: Subscription;
    getStoreTodaysSalesQuotaAchievementsSub: Subscription;
    gotoActionPlanSub: Subscription;
    getAwardedUsersSub: Subscription;
    welcomeMessagesSUb: Subscription;
    loadUserP2WSalesMetricsSub: Subscription;
    getLastSalesExtractSub: Subscription;

    is_p2w_ready: boolean = false;
    bSkipViewChange: boolean = false;
    searchText: string;
    impression_itemID: number;
    actionPlan_itemID: number;
    retail_foundations_userID: number;
    retail_foundations_ap: any;
    p2w_scope_month: string;
    currentUser: User;
    activeUser: User;
    is_p2w_enabled: boolean = false;
    todays_goal: any = false;
    // is_this_month_action_plan_required: boolean = false;
    is_this_month_action_plan_submitted: boolean = false;
    is_todays_goal_required: boolean = false;
    is_portal_initialized: boolean = false;
    dlg: NgbModalRef;
    p2w_dlg: NgbModalRef;

    ngOnDestroy() {
        this.unsubscribeAll(true);
    }

    unsubscribeAll(isDestroyed) {
        if (this.metaDataSub) this.metaDataSub.unsubscribe();
        //if (this.authSub) this.authSub.unsubscribe();
        if (this.currentUserSub) this.currentUserSub.unsubscribe();
        if (this.portalReadySub) this.portalReadySub.unsubscribe();
        if (this.p2wReadySub) this.p2wReadySub.unsubscribe();
        if (this.reloadP2WAchievementsSub) this.reloadP2WAchievementsSub.unsubscribe();
        if (this.idleTimerSub) this.idleTimerSub.unsubscribe();
        if (this.currentViewSub) this.currentViewSub.unsubscribe();
        if (this.emailTemplatesSub) this.emailTemplatesSub.unsubscribe();
        if (this.allUsersSub) this.allUsersSub.unsubscribe();
        if (this.smsCensorshipSub) this.smsCensorshipSub.unsubscribe();
        if (this.dailyCampaignIntroSMSLimitSub) this.dailyCampaignIntroSMSLimitSub.unsubscribe();
        if (this.todaysGoalSub) this.todaysGoalSub.unsubscribe();
        if (this.getThisMonthActionPlansSub) this.getThisMonthActionPlansSub.unsubscribe();
        if (this.getTodaysGoalSub) this.getTodaysGoalSub.unsubscribe();
        if (this.getConsultantSalesQuotaAchievementsSub) this.getConsultantSalesQuotaAchievementsSub.unsubscribe();
        if (this.getConsultantSalesGoalAchievementsSub) this.getConsultantSalesGoalAchievementsSub.unsubscribe();
        if (this.getTodaysConsultantSalesGoalAchievementsSub) this.getTodaysConsultantSalesGoalAchievementsSub.unsubscribe();
        if (this.getStoreSalesQuotaAchievementsSub) this.getStoreSalesQuotaAchievementsSub.unsubscribe();
        if (this.getStoreTodaysSalesQuotaAchievementsSub) this.getStoreTodaysSalesQuotaAchievementsSub.unsubscribe();

        if (isDestroyed) {
            if (this.searchTextSub) this.searchTextSub.unsubscribe();
            if (this.gotoItemSub) this.gotoItemSub.unsubscribe();
            if (this.gotoActionPlanSub) this.gotoActionPlanSub.unsubscribe();
        }
    }

    ngOnInit() {
        this.uscStoreService.setTitle('U.S. Cellular - Making Sales Happen');

        this.authService.validateAuthentication();
        this.authSub = this.authService.isAuthenticated.subscribe(
            auth => {
                if (auth) {
                    this.unsubscribeAll(false);
                    var auth_user = this.authService.getAuth();
                    if (this.uscStoreService.getItemCustomFieldValue(auth_user, "Custom Access Code") == "Portal Scheduling") {
                        this.router.navigateByUrl(auth_user.home_page);
                    } else {
                        this.snInit();
                    }
                }
            }
        );

        this.uscStoreService.p2wScopeMonth.subscribe(m => {
            this.p2w_scope_month = m == "" ? this.uscStoreService.getThisMonthActionPlanSubject() : m;
        })
    }

    showLoadingDlg(msg: string, show_process_icon: boolean = true):NgbModalRef {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.data = { };
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config = { msg: msg, show_process_icon: show_process_icon };
        return modalRef;
    }    

    processNextNonBlockingRequests(requests:string[], request_index:number) {
        if (request_index >= requests.length) return;  // safe guard in case element out of bound reference
        var request = requests[request_index];
        this.sessionService.log("processNextNonBlockingRequests: [" + request_index.toString() + "]" + request); 
        switch (request) {
            case "storeVisitTeamStores":
                this.sessionService.log("Store Visit Team Stores Loading:", new Date()); 
                this.uscStoreService.loadStoreVisitTeamStores();
                this.uscStoreService.storeVisitTeamStores.subscribe(data => {
                    if (data) this.sessionService.log("Store Visit Team Stores Loaded", new Date());
                    this.processNextNonBlockingRequests(requests, ++request_index);
                })
                break;
            case "loadAllUsers":   
                this.sessionService.log("Users Loading:", new Date()); 
                this.adminService.loadAllUsers();
                this.adminService.allUserLoaded.subscribe(bLoaded => {
                    if (bLoaded) this.sessionService.log("Users Loaded", new Date());
                    this.processNextNonBlockingRequests(requests, ++request_index);
                })
                break;
            case "loadMetadata":
                this.sessionService.log("Meta Data Loading:", new Date()); 
                this.metaDataSub = this.metadataService.loadMetadata().subscribe(
                    data => { 
                        this.sessionService.log("Meta Data Loaded", new Date());
                        this.processNextNonBlockingRequests(requests, ++request_index);
                    },
                    err => { 
                        this.processNextNonBlockingRequests(requests, ++request_index);
                        this.sessionService.log(err); 
                    }
                )                
                break;
            case "loadEmailTemplates":
                this.sessionService.log("Email Templates Loading:", new Date());
                this.emailTemplatesSub = this.uscStoreService.loadEmailTemplates().subscribe(
                    data => { 
                        this.sessionService.log("Email Templates Loaded", new Date());
                        this.processNextNonBlockingRequests(requests, ++request_index);
                    },
                    err => { 
                        this.processNextNonBlockingRequests(requests, ++request_index);
                        this.sessionService.log(err); 
                    }
                )
                break;                
            case "loadSmsCensorship":
                this.sessionService.log("SMS Censorship Loading:", new Date());
                this.smsCensorshipSub = this.uscStoreService.loadSmsCensorship().subscribe(
                    data => { 
                        this.sessionService.log("SMS Censorship Loaded", new Date());
                        this.processNextNonBlockingRequests(requests, ++request_index);
                    },
                    err => { 
                        this.processNextNonBlockingRequests(requests, ++request_index);
                        this.sessionService.log(err); 
                    }
                )
                break;
            case "loadTrainingVideos":
                this.sessionService.log("Training Videos Loading:", new Date());
                this.smsCensorshipSub = this.uscStoreService.loadTrainingVideos().subscribe(
                    data => { 
                        console.log(data);
                        this.sessionService.log("Training Videos Loaded", new Date());
                        this.processNextNonBlockingRequests(requests, ++request_index);
                    },
                    err => { 
                        this.processNextNonBlockingRequests(requests, ++request_index);
                        this.sessionService.log(err); 
                    }
                )
                break;
            case "loadP2wDetailInfo":
                this.sessionService.log("P2W detail Info Loading:", new Date());
                this.smsCensorshipSub = this.uscStoreService.loadP2wDetailInfo().subscribe(
                    data => { 
                        this.sessionService.log("P2W detail Info Loaded", new Date());
                        this.processNextNonBlockingRequests(requests, ++request_index);
                    },
                    err => { 
                        this.processNextNonBlockingRequests(requests, ++request_index);
                        this.sessionService.log(err); 
                    })                
                break;
            case "getDailyCampaignIntroSMSLimit":
                this.sessionService.log("Daily Campaign Intro SMS Limit Loading:", new Date());
                this.dailyCampaignIntroSMSLimitSub = this.uscStoreService.getDailyCampaignIntroSMSLimit().subscribe(
                    result => {
                        this.sessionService.log("getDailyCampaignIntroSMSLimit", new Date());
                        this.processNextNonBlockingRequests(requests, ++request_index);
                    },
                    err => { 
                        this.processNextNonBlockingRequests(requests, ++request_index);
                        this.sessionService.log(err); 
                    })
                break;
            case "calendarEvents":
                this.sessionService.log("Calendar EVents Loading:", new Date());
                this.uscStoreService.reloadCalendarEvents("init");       
                this.dailyCampaignIntroSMSLimitSub = this.uscStoreService.calendarEvents.subscribe(
                    result => {
                        this.sessionService.log("Calendar EVents Loaded", new Date());
                        this.processNextNonBlockingRequests(requests, ++request_index);
                    }, err => { 
                        this.processNextNonBlockingRequests(requests, ++request_index);
                        this.sessionService.log(err); 
                    }
                )
                break;
        }
    }

    // List of Requested Data before allowing portal access
    // 1. This month's action plan  (AP maybe mandatory)
    // 2. check if this month's user quota got changed or not (AP maybe mandatory)
    // 3. today's daily goal (AP maybe mandatory)
    // 4. get awarded users
    processBlockingConcurrentRequests() {
        if (this.is_p2w_enabled) {
            this.initializeP2WAchievements(true);
            this.uscStoreService.setPortalInitializationItem("getThisMonthActionPlans", "initializing");
            this.uscStoreService.setPortalInitializationItem("getTodaysGoal", "initializing");
            this.getThisMonthActionPlansSub = this.uscStoreService.getThisMonthActionPlans().subscribe(result => {
                this.is_this_month_action_plan_submitted = (result != null && (result.cs_status == this.uscStoreService.action_plan_status_requested || result.cs_status == this.uscStoreService.action_plan_status_approved));
                //console.log("=======================================is_this_month_action_plan_submitted", this.is_this_month_action_plan_submitted);
                this.uscStoreService.is_this_month_action_plan_required = this.uscStoreService.isActionPlanRequired() && (result == null || result.cs_status == this.uscStoreService.action_plan_status_draft) && !this.uscStoreService.isLeader();
                this.uscStoreService.setPortalInitializationItem("getThisMonthActionPlans", "initialized");
                this.sessionService.log("This Month Action Plan Loaded", new Date());

                this.getTodaysGoalSub = this.uscStoreService.getTodaysGoal().subscribe(result => {
                    this.uscStoreService.setPortalInitializationItem("getTodaysGoal", "initialized");
                    this.sessionService.log("Today's Goal Loaded", new Date());
                }) 
            })

            if (!this.uscStoreService.isLeader()) {
                this.uscStoreService.setP2WInitializationItem("hasCurrentMonthQuotaChanged", "initializing");
                this.hasCurrentMonthQuotaChangedSub = this.uscStoreService.getHasCurrentMonthQuotaChanged().subscribe(result => {
                    this.uscStoreService.setP2WInitializationItem("hasCurrentMonthQuotaChanged", "initialized");
                    this.sessionService.log("Has Current Month Quota Changed Received", new Date());
                })
            }

            if (this.uscStoreService.isUSCellCorp()) {
                this.uscStoreService.setPortalInitializationItem("getAwardedUsers", "initializing");                
                this.getAwardedUsersSub = this.uscStoreService.getAwardedUsers().subscribe(result => {
                    this.uscStoreService.setPortalInitializationItem("getAwardedUsers", "initialized");
                    this.sessionService.log("Awarded Users Loaded", new Date());
                }) 
            }

            this.todaysGoalSub = this.uscStoreService.todaysGoal.subscribe(goal => {
                var todays_goal_submitted = false;
                //console.log("=======================================is_todays_goal_required", this.is_todays_goal_required);
                if (goal && goal.cs_status == this.uscStoreService.daily_goal_status_submitted) {
                    this.is_todays_goal_required = false;
                    todays_goal_submitted = (this.todays_goal == null || this.todays_goal.status != this.uscStoreService.daily_goal_status_submitted);
                } else if (!this.uscStoreService.isActionPlanRequired() && !this.is_this_month_action_plan_submitted) {         // AP is optional for Agents, and DG is mandatory only if AP is submitted
                    this.is_todays_goal_required = false;
                }
                this.todays_goal = goal;
                var view = this.uscStoreService.view_first;   // make first impression the first impression as the initial view
                // console.log("=======================================todays_goal_submitted", todays_goal_submitted);
                // console.log("=======================================is_todays_goal_required", this.is_todays_goal_required);
                if (todays_goal_submitted && this.is_portal_initialized) this.uscStoreService.setCurrentView(this.uscStoreService.view_first);
            })
        }

        // For USC Agent, we need to load the user list first as it has a tighter dependency 
        if (this.uscStoreService.isUSCellAgent()) {
            this.uscStoreService.setPortalInitializationItem("loadAgencyTeamUsers", "initializing");
            this.sessionService.log("Users Loading:", new Date()); 
            this.uscStoreService.loadAgencyTeamUsers(this.authService.getActive());
            this.adminService.allUserLoaded.subscribe(bLoaded => {
                if (bLoaded) {
                    this.sessionService.log("Users Loaded", new Date());
                    this.uscStoreService.setPortalInitializationItem("loadAgencyTeamUsers", "initialized");
                }
            })
        }
        
        this.uscStoreService.setPortalInitializationItem("getting_currentUser", "initializing");
        this.currentUserSub = this.authService.currentUser.subscribe(
            user => {
                var authUser = this.authService.getAuth();
                if (authUser && authUser.ID) {
                    this.currentUser = authUser;
                    this.activeUser = user;
                    if (this.uscStoreService.isUSCellAgent()) {
                        // console.log("=======================================*** is_todays_goal_required", this.is_todays_goal_required);
                        this.is_todays_goal_required = this.is_p2w_enabled && (this.activeUser.title == 'Associate' || this.activeUser.title == 'Manager');
                        // console.log("=======================================*** is_p2w_enabled", this.is_p2w_enabled);
                        // console.log("=======================================*** this.activeUser.title", this.activeUser.title);
                        // console.log("=======================================*** is_todays_goal_required", this.is_todays_goal_required);
                    } else {
                        this.is_todays_goal_required = this.is_p2w_enabled && !this.uscStoreService.isLeader();
                    }
                    this.uscStoreService.setPortalInitializationItem("getting_currentUser", "initialized");
                }
            }
        )
    }

    // WARNING: this is a very delicate logic that would control the p2w page flow.  do not change if you are not familiar to it
    protected allowViewSwitching(currentView:string):boolean {
        if (this.uscStoreService.has_current_month_quota_changed && currentView != this.uscStoreService.view_p2w_this_action_plan) return false;
        if (!this.uscStoreService.is_this_month_action_plan_required || currentView == this.uscStoreService.view_p2w_this_action_plan) return true;
        if (this.is_todays_goal_required && currentView != this.uscStoreService.view_p2w_todays_goal) return false;
        return true;
    }

    snInit() {
        // reset session state for switch hierarchy or switch linked user
        this.is_portal_initialized = false;
        this.is_p2w_enabled = this.uscStoreService.isP2WEnabled();
        this.redirectUserToDefaultPage = true;
        // logoff when session is timeout
        this.idleTimerSub = this.sessionService.onIdleTimeout().subscribe(c => {
            this.sessionService.log("Session Timeout");
            this.authService.logoff(true);
        });

        if (this.serialized_non_blocking_requests.length == 0) {
            this.serialized_non_blocking_requests.push("loadTrainingVideos");        
            this.serialized_non_blocking_requests.push("loadSmsCensorship");        
            this.serialized_non_blocking_requests.push("loadP2wDetailInfo");        
            this.serialized_non_blocking_requests.push("getDailyCampaignIntroSMSLimit");        
            this.serialized_non_blocking_requests.push("loadEmailTemplates");        
            if (this.uscStoreService.isStoreVisitTabEnabled()) this.serialized_non_blocking_requests.push("storeVisitTeamStores");
            this.serialized_non_blocking_requests.push("loadMetadata");        
            this.serialized_non_blocking_requests.push("calendarEvents");
            // user list can be loaded as non-blocking request for COR and Telesales, excluding Agent
            if (!this.uscStoreService.isUSCellAgent()) this.serialized_non_blocking_requests.push("loadAllUsers");        
        }
        // view observable: monitor view changes so we can switch switch on demand
        // the search result view will not be handled here, (see searchText observable)
        this.currentViewSub = this.uscStoreService.currentView.subscribe(
            (currentView) => {
                if (currentView == this.uscStoreService.view_plan_2_win) currentView = this.getPlan2WinInitialView();
                if (currentView == this.uscStoreService.view_usc_store_visits) currentView = this.getStoreVisitInitialView();
                var allow_view_switching = this.allowViewSwitching(currentView);
                if (allow_view_switching) {
                    this.currentView = currentView;
                    if (!this.bSkipViewChange) {
                        var view_component: any = null;
                        switch (currentView) {
                            case this.uscStoreService.view_home: view_component = UscHomeComponent; break;
                            case this.uscStoreService.view_first: view_component = UscFirstComponent; break;
                            case this.uscStoreService.view_middle: view_component = UscMiddleComponent; break;
                            case this.uscStoreService.view_lasting: view_component = UscLastingComponent; break;
                            case this.uscStoreService.view_book_of_business: view_component = UscBookOfBusinessComponent; break;
                            case this.uscStoreService.view_search: view_component = UscSearchComponent; break;
                            case this.uscStoreService.view_reports: view_component = UscReportsComponent; break;
                            case this.uscStoreService.view_user_profile: view_component = UscUserProfileComponent; break;
                            case this.uscStoreService.view_campaign_import: view_component = UscCampaignImportComponent; break;
                            case this.uscStoreService.view_manage_campaigns: view_component = UscManageCampaignComponent; break;
                            case this.uscStoreService.view_change_password: view_component = UscPasswordComponent; break;
                            case this.uscStoreService.view_calendar: view_component = UscCalendarViewComponent; break;
                            case this.uscStoreService.view_sms_hosting: view_component = UscSmsHostingComponent; break;
                            case this.uscStoreService.view_plan_2_win_waiting: view_component = UscP2wWaitingComponent; break;
                            case this.uscStoreService.view_p2w_todays_goal: view_component = UscTodaysGoalComponent; break;
                            // case this.uscStoreService.view_p2w_todays_goal: view_component = UscTodaysGoalTableComponent; break;
                            case this.uscStoreService.view_p2w_this_action_plan: view_component = UscActionPlanTableComponent; break;
                            case this.uscStoreService.view_p2w_next_action_plan: view_component = UscActionPlanTableComponent; break;
                            case this.uscStoreService.view_p2w_prev_action_plan: view_component = UscActionPlanTableComponent; break;
                            case this.uscStoreService.view_p2w_payout_estimator: view_component = UscPayoutEstimatorComponent; break;
                            case this.uscStoreService.view_p2w_sales_tracker: view_component = UscSalesTrackerComponent; break;
                            case this.uscStoreService.view_p2w_plan_2_win: view_component = UscTeamSalesTrackerComponent; break;
                            case this.uscStoreService.view_p2w_scorecard: view_component = UscTeamSalesTrackerComponent; break;
                            // case this.uscStoreService.view_p2w_team_this_action_plans: view_component = UscTeamActionPlansComponent; break;
                            // case this.uscStoreService.view_p2w_team_next_action_plans: view_component = UscTeamActionPlansComponent; break;
                            // case this.uscStoreService.view_p2w_previous_action_plans: view_component = UscPreviousActionPlansComponent; break;
                            case this.uscStoreService.view_p2w_team_this_action_plans: view_component = UscP2wTeamActionPlansComponent; break;
                            case this.uscStoreService.view_p2w_team_next_action_plans: view_component = UscP2wTeamActionPlansComponent; break;
                            case this.uscStoreService.view_p2w_previous_action_plans: view_component = UscP2wTeamActionPlansComponent; break;
                            case this.uscStoreService.view_p2w_sales_scorecard: view_component = UscSalesScorecardComponent; break;
                            case this.uscStoreService.view_p2w_goal_gross_adds_detail_results: view_component = UscP2wSalesDetailsComponent; break;
                            case this.uscStoreService.view_p2w_quota_gross_adds_detail_results: view_component = UscP2wSalesDetailsComponent; break;
                            case this.uscStoreService.view_p2w_competitions: view_component = UscP2wCompetitionsComponent; break;
                            case this.uscStoreService.view_p2w_competition_status: view_component = UscP2wCompetitionStatusComponent; break;
                            case this.uscStoreService.view_p2w_associate_detailed_results: view_component = UscP2wAssociateDetailResultsComponent; break;
                            case this.uscStoreService.view_p2w_associate_todays_detailed_results: view_component = UscP2wAssociateDetailResultsComponent; break;
                            case this.uscStoreService.view_retail_foundations: view_component = UscRetailFoundationsComponent; break;
                            // store visits
                            case this.uscStoreService.view_store_visit_checkin: view_component = UscSvtCheckinComponent; break;
                            case this.uscStoreService.view_store_visit_waiting_appt: view_component = UscSvtWaitingComponent; break;
                            case this.uscStoreService.view_store_visit_scheduled_appt: view_component = UscSvtAppointmentsComponent; break;
                            case this.uscStoreService.view_store_visit_serving_now: view_component = UscSvtServingNowComponent; break;
                            case this.uscStoreService.view_store_visit_service_completed: view_component = UscSvtServiceCompletedComponent; break;
                            case this.uscStoreService.view_store_scheduling_setup: view_component = UscStoreSchedulingSetupComponent; break;
                            // uploaded documents
                            case this.uscStoreService.view_uploaded_documents: view_component = UscUploadedDocumentsComponent; break;
                        }

                        this.sessionService.log("currentView switch: " + currentView);

                        if (view_component != null) {
                            this.viewContainer.clear();
                            this.currentViewFactory = this.viewResolver.resolveComponentFactory(view_component);
                            if (currentView == this.uscStoreService.view_calendar) {
                                //this.uscStoreService.reloadCalendarEvents("view_calendar");
                                let ref: ComponentRef<UscCalendarViewComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                            } else if (currentView == this.uscStoreService.view_sms_hosting) {
                                let ref: ComponentRef<UscSmsHostingComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                            } else if (currentView == this.uscStoreService.view_search) {
                                let ref: ComponentRef<UscSearchComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                if (this.impression_itemID > 0) {
                                    ref.instance.itemID = this.impression_itemID;
                                    this.impression_itemID = 0;
                                } else {
                                    ref.instance.searchText = this.searchText;
                                    this.sessionService.log("searchText: " + this.searchText);
                                }
                            } else if (currentView == this.uscStoreService.view_retail_foundations) {
                                let ref: ComponentRef<UscRetailFoundationsComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                // ref.instance.rf_user_ID = this.retail_foundations_userID;
                                ref.instance.rf_ap = this.retail_foundations_ap;
                            } else if (currentView == this.uscStoreService.view_book_of_business) {
                                let ref: ComponentRef<UscBookOfBusinessComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                            } else if (currentView == this.uscStoreService.view_p2w_scorecard) {
                                this.uscStoreService.setP2wTeamSalesTrackerScope(null);
                                let ref: ComponentRef<UscTeamSalesTrackerComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.sales_mode = "quota";
                                this.uscStoreService.setP2WScopeMonth(""); //bug fix clear scope_month selection to ensure Observable doesn't get triggered
                            } else if (currentView == this.uscStoreService.view_p2w_plan_2_win) {
                                this.uscStoreService.setP2wTeamSalesTrackerScope(null);
                                let ref: ComponentRef<UscTeamSalesTrackerComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.sales_mode = "goal";
                                this.uscStoreService.setP2WScopeMonth(""); //bug fix clear scope_month selection to ensure Observable doesn't get triggered
                            } else if (currentView == this.uscStoreService.view_p2w_this_action_plan) {
                                let ref: ComponentRef<UscActionPlanTableComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                                if (this.actionPlan_itemID > 0) { 
                                    ref.instance.item_ID = this.actionPlan_itemID;
                                    this.actionPlan_itemID = 0;
                                }
                            } else if (currentView == this.uscStoreService.view_p2w_next_action_plan) {
                                let ref: ComponentRef<UscActionPlanTableComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                                if (this.actionPlan_itemID > 0) { 
                                    ref.instance.item_ID = this.actionPlan_itemID;
                                    this.actionPlan_itemID = 0;
                                }
                        } else if (currentView == this.uscStoreService.view_p2w_prev_action_plan) {
                                let ref: ComponentRef<UscActionPlanTableComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                                if (this.actionPlan_itemID > 0) { 
                                    ref.instance.item_ID = this.actionPlan_itemID;
                                    this.actionPlan_itemID = 0;
                                }                                
                            } else if (currentView == this.uscStoreService.view_p2w_previous_action_plans) {
                                // let ref: ComponentRef<UscPreviousActionPlansComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                let ref: ComponentRef<UscP2wTeamActionPlansComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_p2w_team_this_action_plans) {
                                // let ref: ComponentRef<UscTeamActionPlansComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                let ref: ComponentRef<UscP2wTeamActionPlansComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_p2w_team_next_action_plans) {
                                // let ref: ComponentRef<UscTeamActionPlansComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                let ref: ComponentRef<UscP2wTeamActionPlansComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_p2w_sales_scorecard) {
                                let ref: ComponentRef<UscSalesScorecardComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = this.uscStoreService.view_p2w_associate_gross_adds_detail_results;
                            } else if (currentView == this.uscStoreService.view_p2w_goal_gross_adds_detail_results || currentView == this.uscStoreService.view_p2w_quota_gross_adds_detail_results) {
                                let ref: ComponentRef<UscP2wSalesDetailsComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                                ref.instance.current_month = this.p2w_scope_month;
                            } else if (currentView == this.uscStoreService.view_p2w_associate_detailed_results) {
                                let ref: ComponentRef<UscP2wAssociateDetailResultsComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_p2w_associate_todays_detailed_results) {
                                let ref: ComponentRef<UscP2wAssociateDetailResultsComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_p2w_competition_status) {
                                let ref: ComponentRef<UscP2wCompetitionStatusComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.competition_ID = 521178;
                            } else if (this.impression_itemID > 0) {
                                let ref: ComponentRef<UscImpressionComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.itemID = this.impression_itemID;
                                this.impression_itemID = 0;
                            } else if (currentView == this.uscStoreService.view_store_visit_checkin) {
                                let ref: ComponentRef<UscSvtCheckinComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_store_visit_waiting_appt) {
                                let ref: ComponentRef<UscSvtWaitingComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_store_visit_scheduled_appt) {
                                let ref: ComponentRef<UscSvtAppointmentsComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_store_visit_serving_now) {
                                let ref: ComponentRef<UscSvtServingNowComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_store_visit_service_completed) {
                                let ref: ComponentRef<UscSvtServiceCompletedComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                ref.instance.view = currentView;
                            } else if (currentView == this.uscStoreService.view_uploaded_documents) {
                                let ref: ComponentRef<UscUploadedDocumentsComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                                //ref.instance.view = currentView;
                            } else {
                                let ref: ComponentRef<UscImpressionComponent> = this.viewContainer.createComponent(this.currentViewFactory);
                            }
                        }
                    } else {    
                        this.bSkipViewChange = false;
                    }
                }
            }
        )

        this.dlg = this.showLoadingDlg("Initializing Portal...");
        this.processBlockingConcurrentRequests();

        this.portalReadySub = this.uscStoreService.portalReady.subscribe(r => {
            if (r && !this.is_portal_initialized) {
                this.dlg.dismiss();
                this.is_portal_initialized = true;
                // this.continueInitializeOnPotalReady();
                this.processNextNonBlockingRequests(this.serialized_non_blocking_requests, 0);

                if (this.activeUser.ID && this.redirectUserToDefaultPage) {
                    if (this.is_p2w_enabled) {
                        console.log("portalReady -> goto p2w initialized view");
                        if (this.uscStoreService.has_current_month_quota_changed || this.uscStoreService.is_this_month_action_plan_required) 
                            this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_this_action_plan);
                        else if (this.is_todays_goal_required)
                             this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_todays_goal);
                        else 
                            this.uscStoreService.setCurrentView(this.uscStoreService.view_first);
                        
                    } else {
                        if (!this.uscStoreService.isLeader()) {
                            if (this.uscStoreService.isUSCellAgent() || this.uscStoreService.isUSCellCorp()) {
                                this.uscStoreService.setCurrentView(this.uscStoreService.view_calendar);
                            } else {
                                this.uscStoreService.setCurrentView(this.uscStoreService.view_first);
                            }
                        } else {
                            this.uscStoreService.setCurrentView(this.uscStoreService.view_home);
                        }
                        this.redirectUserToDefaultPage = false;
                    }
                } else {
                    this.sessionService.log('user: ' + this.activeUser.ID);
                    if (this.activeUser == undefined) this.redirectUserToDefaultPage = true;
                    else this.uscStoreService.setCurrentView(this.currentView);
                }
            }
        })

        this.p2wReadySub = this.uscStoreService.p2wReady.subscribe(r => {
            if (r) {
                this.is_p2w_ready = true;
                if (this.p2w_dlg) this.p2w_dlg.dismiss();
            } 
        });
    }

    continueInitializeOnPotalReady() {
        this.sessionService.log("Meta Data Loading:", new Date()); 
        this.metaDataSub = this.metadataService.loadMetadata().subscribe(
            data => { 
                // this.uscStoreService.setPortalInitializationItem("loadMetadata", "initialized");
                this.sessionService.log("Meta Data Loaded", new Date());
            },
            err => { this.sessionService.log(err) }
        )

        this.sessionService.log("Email Templates Loading:", new Date());
        this.emailTemplatesSub = this.uscStoreService.loadEmailTemplates().subscribe(
            data => { 
                //this.uscStoreService.setPortalInitializationItem("loadEmailTemplates", "initialized");
                this.sessionService.log("Email Templates Loaded", new Date()) 
            },
            err => { this.sessionService.log(err) }
        )

        this.sessionService.log("SMS Censorship Loading:", new Date());
        this.smsCensorshipSub = this.uscStoreService.loadSmsCensorship().subscribe(
            data => { 
                //this.uscStoreService.setPortalInitializationItem("loadSmsCensorship", "initialized");
                this.sessionService.log("SMS Censorship Loaded", new Date()) 
            },
            err => { this.sessionService.log(err) }
        )

        this.sessionService.log("P2W detail Info Loading:", new Date());
        this.smsCensorshipSub = this.uscStoreService.loadP2wDetailInfo().subscribe(
            data => { 
                //this.uscStoreService.setPortalInitializationItem("loadSmsCensorship", "initialized");
                this.sessionService.log("P2W detail Info Loaded", new Date()) 
            },
            err => { this.sessionService.log(err) }
        )                

        this.sessionService.log("Daily Campaign Intro SMS Limit Loading:", new Date());
        this.dailyCampaignIntroSMSLimitSub = this.uscStoreService.getDailyCampaignIntroSMSLimit().subscribe(result => {
            this.sessionService.log("getDailyCampaignIntroSMSLimit");
        })

        this.sessionService.log("Calendar EVents Loading:", new Date());
        this.uscStoreService.reloadCalendarEvents("init");
    }

    initializeP2WAchievements(bReload:boolean = false) {
        this.uscStoreService.setP2WInitializationItem("getConsultantSalesQuotaAchievements", "initializing");
        this.uscStoreService.setP2WInitializationItem("getConsultantSalesGoalAchievements", "initializing");
        this.uscStoreService.setP2WInitializationItem("getTodaysConsultantSalesGoalAchievements", "initializing");
        this.uscStoreService.setP2WInitializationItem("getStoreSalesQuotaAchievements", "initializing");
        this.uscStoreService.setP2WInitializationItem("getStoreTodaysSalesQuotaAchievements", "initializing");

        this.getConsultantSalesQuotaAchievementsSub = this.uscStoreService.getConsultantSalesQuotaAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getConsultantSalesQuotaAchievements", "initialized");
            this.sessionService.log('USC Consultant Sales Quota Achievements Loaded', new Date());
        })

        this.getConsultantSalesGoalAchievementsSub = this.uscStoreService.getConsultantSalesGoalAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getConsultantSalesGoalAchievements", "initialized");
            this.sessionService.log('USC Consultant Sales Goal Achievements Loaded', new Date());
        })

        this.getTodaysConsultantSalesGoalAchievementsSub = this.uscStoreService.getTodaysConsultantSalesGoalAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getTodaysConsultantSalesGoalAchievements", "initialized");
            this.sessionService.log("USC Today's Consultant Sales Goal Achievements Loaded", new Date());
        })

        this.getStoreSalesQuotaAchievementsSub = this.uscStoreService.getStoreSalesQuotaAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getStoreSalesQuotaAchievements", "initialized");
            this.sessionService.log('USC Store Sales Quota Achievements Loaded', new Date());
        })
        
        this.getStoreTodaysSalesQuotaAchievementsSub = this.uscStoreService.getStoreTodaysSalesQuotaAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getStoreTodaysSalesQuotaAchievements", "initialized");
            this.sessionService.log("USC Today's Store Sales Quota Achievements Loaded", new Date());
        })

        this.uscStoreService.setP2WInitializationItem("getLastSalesExtract", "initializing");
        this.getLastSalesExtractSub = this.uscStoreService.getLastSalesExtract().subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getLastSalesExtract", "initialized");
            this.sessionService.log("Last Sales Extract Loaded", new Date());
        })

        if (!this.uscStoreService.isLeader()) {
            this.uscStoreService.setP2WInitializationItem("loadUserP2WSalesMetrics", "initializing");
            this.loadUserP2WSalesMetricsSub = this.uscStoreService.loadUserP2WSalesMetrics().subscribe(result => {
                this.uscStoreService.setP2WInitializationItem("loadUserP2WSalesMetrics", "initialized");
                this.sessionService.log("User P2W Sales Metrics Loaded", new Date());
            })            
        }
    }

    getPlan2WinInitialView(): string {
        // if (isDevMode()) return this.uscStoreService.view_p2w_competition_status;
        if (this.uscStoreService.isLeader()) return this.uscStoreService.view_p2w_scorecard;
        if (this.uscStoreService.is_this_month_action_plan_required) return this.uscStoreService.view_p2w_action_plan_table;
        if (this.uscStoreService.has_current_month_quota_changed) return this.uscStoreService.view_p2w_action_plan_table;
        if (this.is_todays_goal_required) return this.uscStoreService.view_p2w_todays_goal;
        if (this.is_p2w_enabled && !this.is_p2w_ready) return this.uscStoreService.view_plan_2_win_waiting;
        return this.uscStoreService.view_p2w_sales_tracker;        
        // return this.uscStoreService.view_first;
    }

    getStoreVisitInitialView(): string {
        return this.uscStoreService.view_store_visit_waiting_appt;
    }

    ngAfterContentInit() {
        // view observable: monitor searchText changes so we can swith to search view if needed
        this.searchTextSub = this.uscStoreService.searchText.subscribe(
            (searchText) => {
                if (searchText.length > 0) {
                    this.sessionService.log('usc-store searchText Observable');
                    this.searchText = searchText;
                    this.uscStoreService.setCurrentView(this.uscStoreService.view_search);
                }
            }
        )

        // view observable: monitor searchText changes so we can swith to search view if needed
        this.gotoItemSub = this.uscStoreService.gotoItem.subscribe(
            (item) => {
                var view = null;
                if (item) {
                    this.viewContainer.clear();
                    this.impression_itemID = item.dl_ID;
                    if (this.uscStoreService.isUSCellRetail()) {
                        if (this.uscStoreService.isUSCellCorp() && item.u_title == 'Store') {
                            view = this.uscStoreService.view_search;
                        } else if (this.uscStoreService.isUSCellAgent()) {
                            if (item.u_title == 'Store' && this.currentUser.title == 'Store' && item.dl_account_type == '') {
                                view = this.uscStoreService.view_search;
                            } else if (item.u_title == 'Store' && this.currentUser.title != 'Store') {
                                view = this.uscStoreService.view_search;
                            }
                        }
                    } else if (this.uscStoreService.isUSCellTelesales()) {
                        if (this.uscStoreService.isUSCellTelesales() && item.u_title == 'Store') {
                            view = this.uscStoreService.view_search;
                        }
                    }

                    if (view == null) {
                        switch (item.dl_type) {
                            case "First Impression": view = this.uscStoreService.view_first; break;
                            case "Middle Impression": view = this.uscStoreService.view_middle; break;
                            case "Lasting Impression": view = this.uscStoreService.view_lasting; break;
                        }
                    }
                    this.uscStoreService.setCurrentView(view);
                }
            }
        )

        this.gotoActionPlanSub = this.uscStoreService.gotoActionPlan.subscribe(ap => {
            if (ap) {
                this.actionPlan_itemID = ap.view_ID;
                if (ap.ap_ID > 0) this.actionPlan_itemID = ap.ap_ID;
                var ap_subject = ap.cs_subject;
                if (ap.ap_subject != null && ap.ap_subject.length > 0) ap_subject = ap.ap_subject;
                if (ap_subject == this.uscStoreService.getThisMonthActionPlanSubject()) {
                    this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_this_action_plan);
                } else if (ap_subject == this.uscStoreService.getNextMonthActionPlanSubject()) {
                    this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_next_action_plan);
                } else {
                    this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_prev_action_plan);
                }
            }
        })

        this.gotoActionPlanSub = this.uscStoreService.gotoRetailFoundations.subscribe(ap => {
            if (ap) {
                this.retail_foundations_userID = ap.ur_user_ID;
                this.retail_foundations_ap = ap;
                this.uscStoreService.setCurrentView(this.uscStoreService.view_retail_foundations);
            }
        })

        this.reloadP2WAchievementsSub = this.uscStoreService.reloadP2WAchievements.subscribe(bReload => {
            if (bReload) {
                this.p2w_dlg = this.showLoadingDlg("Reloading P2W Sales...");
                this.is_portal_initialized = false;
                this.initializeP2WAchievements(true);
            }
        });

        this.uscStoreService.setCurrentView(this.currentView);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-store.component.ts